import axios from 'axios'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: "https://tijian.changyin.sh.cn",
  // baseURL: "http://47.95.213.107",
  headers:{
    "Content-Type":"application/x-www-form-urlencoded"
  },
  // 超时
  timeout: 10000
})
// request拦截器
service.interceptors.request.use(config => {
   config.headers['Content-Type'] = "application/x-www-form-urlencoded"
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?';
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName];
      var part = encodeURIComponent(propName) + "=";
      if (value !== null && typeof(value) !== "undefined") {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            url += subPart + encodeURIComponent(value[key]) + "&";
          }
        } else {
          url += part + encodeURIComponent(value) + "&";
        }
      }
    }
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  console.log(config);
  return config
}, error => {
    console.log(error)
    Promise.reject(error)
})
//这里是所有请求的拦截器
// 响应拦截器

service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    return res.data
  },
  error => {
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js